// @flow
import * as React from 'react';

import { Text } from 'reshaped';

import { useTranslator, mapTags } from '@gandi/translate';

import styles from './InvitationCheckboxWrapper.module.css';

type Props = {
  children: React.Node,
};

const InvitationCheckboxWrapper = ({ children }: Props): React.MixedElement => {
  const { __ } = useTranslator();

  return (
    <>
      {children}
      <div className={styles.help}>
        <Text as="p" variant="caption-1" color="neutral-faded">
          {mapTags(
            __(
              'Contacts must accept the invitation before they ' +
                'can view and manage the domains [[docLink:(learn more)]]. ',
            ),
            ({ docLink }) => ({
              docLink: (
                <a
                  href={__(
                    'https://docs.gandi.net/en/domain_names/common_operations/manage_domain_contacts.html',
                  )}
                  target="_blank"
                  rel="noopener"
                >
                  {docLink}
                </a>
              ),
            }),
          )}
          <br />
          {__(
            'Registries may take some time to update the information on their side.',
          )}
        </Text>
      </div>
    </>
  );
};

export default InvitationCheckboxWrapper;
